import { render, staticRenderFns } from "./PartnerOrdersDetails.vue?vue&type=template&id=a1d68e56&scoped=true&"
import script from "./PartnerOrdersDetails.vue?vue&type=script&lang=js&"
export * from "./PartnerOrdersDetails.vue?vue&type=script&lang=js&"
import style0 from "./PartnerOrdersDetails.vue?vue&type=style&index=0&id=a1d68e56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d68e56",
  null
  
)

export default component.exports